import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {Box} from '@mui/material';
import {reverse} from 'named-urls';
import React from 'react';
import ContactTypes from '../../../../components/ContactTypes';
import routes from '../../../../routes';

const Wrapper = ({title, contact, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}>
        {contact ? (
          <Box display="flex" flex={1} justifyContent="flex-end"><ContactTypes contact={contact}/></Box>
        ) : null}
      </Title>
      <Notice
        display={contact && contact.archived}
        message={[
          'This contact has been archived and is therefore no longer available.',
          contact?.deleted_at ? 'You won\'t be able to modify it unless it is restored.' : 'A relation was archived therefore you can not restore it directly'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['contact']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Contacts', link: routes.contacts.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: routes.archive.index},
  {title: 'Contacts', link: reverse(routes.archive.index, {tab: 'contacts'})}
];

export default Wrapper;
